import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public lat: number = 11.2613038;
  public lng: number = 75.790784;
  public zoom: number = 12;
  
  constructor() { }

  ngOnInit() { }

  subscribe(){ }

}